// import { IGraphic, IStyle } from '../Graphic';
// import { IPath2D } from '../Path';

// // TODO: Path svg <Path path='' />

// export interface IDynamicPathShape {
//   path: IPath2D;
// }

// type ShapeType = 'area' | 'circle' | 'ellipse' | 'line' | 'rect' | 'path';

// export interface IDynamicPath extends IGraphic, Partial<IDynamicPathShape> {
//   type: ShapeType;
//   style?: Partial<IStyle>; // 用户传入什么就是什么
// }
